
import "./popupNomina.css";
import {
  Link,
  useHistory,
  useParams,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import Popup from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";

import React, { useEffect, useState } from "react";
import ApiClient from "../../../services/apiclient";
import { boolean } from "joi";

import ContratoPABS from "../pages/contratos/contratoPABS";
import ContratoNomina from "../pages/contratos/contratoNomina";
import ContratoPersonal from "../pages/contratos/ContratoPersonal";
import { ProgressCircular } from "../pages/Progress";
import AlertMessage from "../alertNomina.component";
import { TramiteCreditoContext } from "../../../context/TramiteCreditoProvider";

export default function PopUp({isPopupVisible, setPopupVisibility}) {

  const history = useHistory();
  const apiClient = ApiClient.getInstance();
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const { credito, updateCredito, deleteCredito } = React.useContext(TramiteCreditoContext);

  

  const contratoRes = {accepted : false};
  const [loading, setLoading] = useState(false);
  const [aceptarAnexos, setaceptarAnexos] = useState(false);
  
  let contrato;
  const [tipoContratro, setTipoContrato] = useState(null);
  

  const [contractInfo, setContractInfo] = useState([]);
  

  
  useEffect(() => {

    creditTypeP();
  }, []);

  const infoContrato = async  () =>{
    const { creditType } = await apiClient.getActiveCredit();
    if(creditType === "pabs"){
      apiClient
      .getContractPabs()
      .then((data) => {
        setContractInfo(data);
        console.log(contractInfo);   
      })
      .catch((error) => {
        setMessage("Esperando aprobación para cargar Tu Contrato.");
        setSeverity("error");
        setOpenMessage(true);
      });
      }else if(creditType === "nomina"){
        apiClient.getContractNomina()
        .then((data) => {
          setContractInfo(data);
          console.log(contractInfo);   
        })
        .catch((error) => {
          setMessage("Esperando aprobación para cargar Tu Contrato.");
          setSeverity("error");
          setOpenMessage(true);
        });
      }else if(creditType ==="personal"){
        apiClient.getContractPersonal()
        .then((data) => {
          setContractInfo(data);
          console.log(contractInfo);   
        })
        .catch((error) => {
          setMessage("Esperando aprobación para cargar Tu Contrato.");
          setSeverity("error");
          setOpenMessage(true);
        });
      }
  }
  const creditTypeP = async ()=>{
    var credito = '';
    if(localStorage.getItem('userLocal')){
      console.log(localStorage.getItem('userLocal'))
      var user = JSON.parse(localStorage.getItem('userLocal'));
      console.log(user)
      credito = user.creditoNomina
    }
    const { creditType } = await apiClient.getActiveCreditNomina(credito);
    console.log('PopUp: ', creditType)
    if(creditType === "nomina" || creditType === "celular" || creditType === "tequila"){

     contrato = setTipoContrato('nomina');
     infoContrato();
    }
  }

  const  aceptar  = async () =>{
    console.log('aceptarAnexos: ',aceptarAnexos)
    var credito = '';
    if(localStorage.getItem('userLocal')){
      console.log(localStorage.getItem('userLocal'))
      var user = JSON.parse(localStorage.getItem('userLocal'));
      console.log(user)
      credito = user.creditoNomina
    }
    if(aceptarAnexos == true){
      setLoading(true);
      const {creditType, id}  = await apiClient.getActiveCreditNomina(credito);
      console.log(creditType)
      contratoRes.accepted = true;
  
  
      if(creditType === "nomina" || creditType === "celular" || creditType === "tequila"){
        if(creditType === "celular"){
            apiClient.dowloandNominaAmortizacion(id).then(r =>{
              apiClient.contratoNominaProduct(contratoRes,creditType).then(r =>{  
                history.push('/dashboard2-nomina');
                setPopupVisibility(false);
                  }).catch(err =>{
                    setLoading(false);
                    setMessage('Ha ocurido un error al aceptar el contrato.');
                    setSeverity('error');
                    setOpenMessage(true);
                  })
            }).catch(err=>{
              console.log('err', err)
            })
        } else {
          apiClient.contratoNominaProduct(contratoRes,creditType).then(r =>{  
            history.push('/dashboard2-nomina');
            setPopupVisibility(false);
              }).catch(err =>{
                setLoading(false);
                setMessage('Ha ocurido un error al aceptar el contrato.');
                setSeverity('error');
                setOpenMessage(true);
              })
        }
        
      }
  
    
    }else{

    }

  };
 

  const rechazar = async  () =>{
    var credito = '';
    if(localStorage.getItem('userLocal')){
      console.log(localStorage.getItem('userLocal'))
      var user = JSON.parse(localStorage.getItem('userLocal'));
      console.log(user)
      credito = user.creditoNomina
    }
    setLoading(true);
    const { creditType } = await apiClient.getActiveCreditNomina(credito);

    contratoRes.accepted = false;

    if(creditType === "nomina" || creditType === "celular" || creditType === "tequila"){
      apiClient.contratoNomina(contratoRes).then(r =>{
        deleteCredito();
        history.push('/solicitud-rechazada-aprobada-nomina/nomina');
        setPopupVisibility(false);
      }).catch(err =>{
        setLoading(false);
        setMessage('Ha ocurido un error al aceptar el contrato.');
        setSeverity('error');
        setOpenMessage(true);
      })
    }
   
  }
  const onclickDescrgar = async() =>{
    var credito = '';
    if(localStorage.getItem('userLocal')){
      console.log(localStorage.getItem('userLocal'))
      var user = JSON.parse(localStorage.getItem('userLocal'));
      console.log(user)
      credito = user.creditoNomina
    }
    
    const { creditType, id } = await apiClient.getActiveCreditNomina(credito);

    contratoRes.accepted = false;

    if(creditType === "nomina" || creditType === "celular" || creditType === "tequila"){
      apiClient.dowloandNominaProduct(id,creditType).then(r =>{
        const link = document.createElement('a');
        const url = URL.createObjectURL(r);
        console.log(url);
        link.href = url;
        link.download = 'contrato.pdf';
        link.click();
      }).catch(err=>{
        console.log('err', err)
      })

      apiClient.dowloandNominaAmortizacion(id).then(r =>{
        const link = document.createElement('a');
        const url = URL.createObjectURL(r);
        console.log(url);
        link.href = url;
        link.download = 'tablaAmortizacion.pdf';
        link.click();

      }).catch(err=>{
        console.log('err', err)
      })

      apiClient.dowloandNominaInstructionLetter(id).then(r =>{
        const link = document.createElement('a');
        const url = URL.createObjectURL(r);
        console.log(url);
        link.href = url;
        link.download = 'cartaInstruccion.pdf';
        link.click();

      }).catch(err=>{
        console.log('err', err)
      })

    }

  }
  const handleChange = () => {
    setaceptarAnexos(!aceptarAnexos);
  };
  const handleClose = () => {
    setOpenMessage(false);
  };
  return (
    <div>
       <AlertMessage
            open={openMessage}
            message={message}
            handleClose={handleClose}
            severity={severity}
          />
      <Popup
        visible={isPopupVisible}
        closeOnOutsideClick={false}
        width={1000}
        height={350}
        showTitle={false}
        onHiding={aceptar}
      >
        <ScrollView width="100%" height="100%">
          <div id="textBlock">

          {/* {
            tipoContratro == null
            ?
            null
            : 
            tipoContratro == 'nomina' ? <ContratoNomina contractInfo={contractInfo}/> : 
            tipoContratro == 'personal' ? <ContratoPersonal contractInfo={contractInfo}/> :
            tipoContratro == 'pabs' ?  <ContratoPABS contractInfo={contractInfo}/>: null
          } */}

              <h3 style={{textAlign: 'center', paddingBottom: 20}}>Para continuar necesitar aceptar el contrato.</h3>
              <div className="avisoContent">
              <span style={{ fontSize: 14, marginLeft: 5 }}>
                Probenso Group, Sociedad Anónima, Sociedad Financiera  de Objeto Múltipe, Entidad No Regulada (E.N.R.), con domicilio en Ures Sur 137, Colonia Centro, Tepic, 63000, Nayarit, México es el responsable de sus datos personales.Utilizaremos tus datos personales para los siguientes fines indispensables: (i) Crear tu cuenta de usuario en la plataforma alojada en https://percapita.mx/; (ii) Identificarte como usuario de la plataforma alojada en https://percapita.mx/; (iii) Generar el expediente de solicitud de tu crédito; (iv) Consultar tu historial y capacidad crediticia;  (v) Decidir si se aprueba o rechaza tu solicitud  de crédito, y; (vi) Firmar los contratos de crédito que sean aprobados.Para conocer el aviso de privacidad integral, por favor haz <a href="/aviso-de-privacidad" target="_blank" style={{ fontSize: 14, marginLeft: 5 }}>click aquí.</a>
              </span>

              </div>
              <div className="avisoContent" style={{marginTop: 20}}>
              <label  style={{ marginLeft: 5}}>
                <input style={{float: 'left', width: '10px'}} type="checkbox"checked={aceptarAnexos}
                onChange={handleChange}
                />
                <span> Confirmo que he leído y me obligo a cumplir con el </span>
              </label>
                <a onClick={onclickDescrgar} style={{textDecoration: 'underline', cursor: 'pointer', paddingLeft: '5px'}}>Contrato de Crédito.</a>
              </div>
            <div className="b__bottom2 button-center">
            <button className="btn blue marginAviso" type="submit" onClick={aceptar} disabled={loading}>
                  <ProgressCircular loading={loading} title='Aceptar'/>
                  </button>
                  <button className="btn blue" type="submit" onClick={rechazar} disabled={loading}>
                    Rechazar 
                  </button>
         

            </div>
          </div>
        </ScrollView>
      </Popup>

    </div>
  );
}
